import {IEventParams} from '@signage/interface/dist/IEventParams';
import {ICachingService} from '@signage/interface/dist/ICachingService';
import {IPlayer} from './IPlayer';
import {ViewContainerRef} from '@angular/core';
import {Observable} from "rxjs";


export interface IPlayerService {
  init(): Observable<any>;
  os: string;
  appType: string
  appVersion: string;
  libVersion: string;
  extensionVersion: string;

  businessDomain: string;
  businessId: number;

  setDevMode(mode: boolean);

  eventParams: IEventParams;
  caching: ICachingService;
  createScene(entry: ViewContainerRef, parentPlayer: IPlayer, editMode: boolean): IPlayer
  removeScene(entry: ViewContainerRef, player: IPlayer): void;
  clearSchedules();
  clearCircular(): void;
  isPlaying(): boolean;
  circularSceneId: number;
  studioChannel$;
  showFps: boolean;
  reload(): void;

  getLogTags();
};
